// Library Scope
// -------------------

/* Component */
document.addEventListener('alpine:init', () => {
    window.Alpine.store('libraryStore', {
        loggedIn: false,
    });

    /** COMPONENTS **/
    window.Alpine.data('libraryComponent', (data) => ({
        category: '',
        allDocuments: {},
        filteredDocuments: {},
        chosenCategories: [],
        chosenRubrics: [],
        searchText: '',
        sort: 'default',
        pageRef: data.refSite ?? 'library_overview',
        leadNuturingHandle: data.leadNuturingHandle,
        loading: true,
        allCategories: data.allCategories ? JSON.parse(JSON.stringify(data.allCategories)) : [],
        allRubrics: data.allRubrics ? JSON.parse(JSON.stringify(data.allRubrics)) : [],
        changedFilterValues: {
            ['@multi-select-on-change.window'](event) {
                if (event.detail.fieldName === 'choose_category') {
                    if (Object.keys(event.detail.values).length > 0) {
                        this.chosenCategories = event.detail.values;
                    } else {
                        this.chosenCategories = this.allCategories;
                    }
                } else if (event.detail.fieldName === 'choose_rubrics') {
                    if (Object.keys(event.detail.values).length) {
                        this.chosenRubrics = event.detail.values;
                    } else {
                        this.chosenRubrics = this.allRubrics;
                    }
                }
                this.filterElements();
            },
            ['@single-select-on-change.window'](event) {
                if (event.detail.fieldName === 'library_sort') {
                    this.sort = event.detail.value;
                    this.sortElements();
                }
            },
            ['@text-search-changed.window'](event) {
                this.searchText = event.detail.value.toLowerCase();
                this.filterElements();
            },
        },
        init() {
            window.getRequest({
                params: {
                    action: '/bx-module/library/documents',
                },
            }).then((response) => {
                this.allDocuments = JSON.parse(JSON.stringify(response.data.documents));
                this.chosenCategories = this.allCategories;
                this.chosenRubrics = this.allRubrics;
                this.loading = false;
                this.$verifyLibraryCookie(this.pageRef);

                // URL Parameter check
                this.category = new URLSearchParams(location.search).get('q') || '';

                if (Object.keys(this.allDocuments).length) {
                    this.filteredDocuments = this.allDocuments; //JSON.parse(JSON.stringify(this.allDocuments));

                    // check if item is enabled for overview
                    this.filteredDocuments = this.filteredDocuments
                        .filter((item) => {
                            return item.enabled_for_overview;
                        });
                }
            });

            // watch category dropdown field
            this.$watch('category', (value) => {
                const url = new URL(window.location.href);
                if (value === ''){
                    url.searchParams.delete('q')
                } else {
                    url.searchParams.set('q', value)
                }
                history.pushState(null, document.title, url.toString());
            });
        },
        filterElements() {
            this.filteredDocuments = this.allDocuments
                // check if item is enabled for overview
                .filter((item) => {
                    return item.enabled_for_overview;
                })

                // category & rubric filter
                .filter((item) => {
                    let foundInCategories = this.compareObjects(this.chosenCategories, item.categories);
                    let foundInRubrics = this.compareObjects(this.chosenRubrics, item.rubrics);

                    if (foundInCategories && foundInRubrics) {
                        return item;
                    }
                })

                // search for text
                .filter((item) => {
                    return (item.headline.toLowerCase().indexOf(this.searchText) > -1 || item.document_short_description.toLowerCase().indexOf(this.searchText) > -1) || this.searchText === '';
                });
        },
        sortElements() {
            if (this.sort === 'default') {
                this.filteredDocuments = this.allDocuments;
                this.filterElements();
            }

            if (this.sort === 'newest') {
                this.filteredDocuments.sort((docA, docB) => {
                    return (new Date(docB.postDate.date)) - (new Date(docA.postDate.date));
                })
            }

            // sort algorithm for lexicographical sort
            if (this.sort === 'name') {
                this.filteredDocuments.sort(function (docA, docB) {
                    if (docA.headline < docB.headline) {
                        return -1;
                    }
                    if (docA.name > docB.name) {
                        return 1;
                    }
                    return 0;
                });
            }
        },
        resetFilters() {
            // Todo can we set this.sort inside the dispatched event?
            this.chosenCategories = this.allCategories;
            this.chosenRubrics = this.allRubrics;
            this.category = '';
            this.sort = 'default';

            /* reset all three filters via event, so the original form filter fields know about the new value too
               order: resetFilters() -> value is changed on field -> because the value is changed on the field,
               the events multidropdown-filter-changed and library-sort-changed are triggered
               which update the local filter variables: chosenCategories, chosenRubrics and sort
             */
            window.dispatchEvent(new CustomEvent('reset-text-search', {
                detail: {
                    value: '',
                }
            }));
            window.dispatchEvent(new CustomEvent('reset-categories', {
                detail: {
                    fieldName: 'choose_category',
                    value: {},
                    values: {},
                }
            }));
            window.dispatchEvent(new CustomEvent('reset-rubrics', {
                detail: {
                    fieldName: 'choose_rubrics',
                    value: {},
                    values: {},
                }
            }));
            window.dispatchEvent(new CustomEvent('reset-library-sort', {
                detail: {
                    fieldName: 'library_sort',
                    value: 'default',
                    values: {},
                }
            }));

            // Filter all elements
            this.filterElements();
        },
        compareObjects(filter, item) {
            for (let key in filter) {
                if (item.hasOwnProperty(key)) {
                    return true;
                }
            }
        },
    }))

    window.Alpine.data('libraryEntry', () => ({
        init() {
            // verify cookie
            this.$verifyLibraryCookie('library_detail');
        }
    }));

    window.Alpine.data('library', (config) => ({
        modalName: config.modalName ?? '',
        successModal: config.successModal ?? '',
        infoModal: config.infoModal ?? '',
        errorModal: config.errorModal ?? '',
        init() {
            // this value will by default to true unless the form is not submit yet
            this.$store.modalStore[this.modalName + 'Status'] = true;

            this.showSuccessMessage();
        },
        openLibraryModal() {
            if(!this.validateCookie('WEBSITE_GATED_CONTENT_KEY') && !this.validateCookie('WEBSITE_USER_AUTH')) {
                // set global key to true to prevent body scrolling
                this.$store.modalStore.openModal = true;
                if (document.querySelector('form[data-firstfieldautofocus="true"]')) {
                    setTimeout(() => initFocusObserverForForms(), 50);
                }

                // open form only if modalNameStatus is not submitted yet, status: ok
                if (this.$store.modalStore[this.modalName + 'Status']) {
                    this.$store.modalStore.currentModalName = this.modalName;
                    if (document.querySelector('form[data-firstfieldautofocus="true"]')) {
                        setTimeout(() => initFocusObserverForForms(), 50);
                    }
                } else {
                    // show success modal and say out that the form already was submitted
                    this.$store.modalStore.currentModalName = this.successModal;
                }
            }
        },
        showSuccessMessage() {
            if(new URLSearchParams(location.search).get('modal')) {
                this.$store.modalStore.openModal = true;
                this.$store.modalStore[this.modalName + 'Status'] = false;
                this.$store.modalStore.currentModalName = this.successModal;
            } else if(new URLSearchParams(location.search).get('infoModal') && (this.validateCookie('WEBSITE_GATED_CONTENT_KEY') || this.validateCookie('WEBSITE_USER_AUTH'))) {
                // cleanup url and remove url parameter für infoModal
                const url = new URL(window.location.href);
                url.searchParams.delete('infoModal');
                history.pushState(null, document.title, url.toString());

                this.$store.modalStore.openModal = true;
                this.$store.modalStore[this.modalName + 'Status'] = false;
                this.$store.modalStore.currentModalName = this.infoModal;
            }
        },
        validateCookie(cookieName) {
            return document.cookie.indexOf(cookieName) !== -1;
        },
    }));

    /** MAGICS **/
    window.Alpine.magic('verifyLibraryCookie', () => (trackingComponent) => {
        window.getRequest({
            params: {
                action: '/app-bexio-forms/gated-content/is-valid-cookie'
            },
        }).then((response) => {
            // collect all ctas
            const ctas = document.querySelectorAll('[data-target="looked-download"]');
            const libraryRegisterCard = document.getElementById('library-register-card');
            if(response.data.valid) {
                window.Alpine.store('libraryStore').loggedIn = true;
                // set to each cta the data-target attribute
                ctas.forEach((cta, index) => {
                    // Change cta only if value is not empty
                    if(cta.value !== '') {
                        for (let h = 0; h < cta.childNodes.length; h++) {
                            if (cta.childNodes.item(h).nodeName === "svg") {
                                if(h === 0) {
                                    // Icon lock
                                    cta.childNodes.item(h).classList.add('hidden');
                                } else {
                                    // Icon unlock
                                    cta.childNodes.item(h).classList.remove('hidden');
                                    // swap colors for cta
                                    cta.classList.remove('secondary');
                                    cta.classList.add('primary');
                                }
                            }
                            if (cta.childNodes.item(h).nodeName === "SPAN") {
                                cta.childNodes.item(h).textContent = cta.dataset.titleUnlocked;
                            }
                        }
                    }
                });
                // card to register now should disappear if user is logged in
                if(libraryRegisterCard !== null)
                    libraryRegisterCard.classList.add('hidden');
            } else {
                // reset data-track-element name for premium ctas
                ctas.forEach((cta, index) => {
                    let fileName = cta.dataset.filename;
                    let documentType = cta.dataset.documentType;
                    cta.setAttribute("data-track-element", 'bexio.' + trackingComponent + '.link.' + documentType + '.unlock_' + fileName);
                })
            }
        });
    });

    window.Alpine.magic('verifyLibrary', () => (asset_id, category) => {
        window.getRequest({
            params: {
                action: '/app-bexio-forms/gated-content/verify-gated-content',
                asset_id: asset_id,
                category: category,
            },
        }).then((response) => {
            if(response.data.verify) {
                // TODO: remove these code-lines after successful tested
                // old way
                window.location.href = response.data.url;

                /*setTimeout(() => {
                    window.open(response.data.url,'_blank');
                })*/
            }
        });
    });
});

